import { isValidUrl } from '@core/utils';
import { UiService } from '@services/ui/ui.service';
import { AppService } from '@services/app/app.service';
import { Injectable } from '@angular/core';
import { HelpLinks } from '@core/models';

@Injectable({
  providedIn: 'root'
})
export class HelpService {
  constructor(private appService: AppService, private uiService: UiService) {}

  openLink(code: HelpLinks): void {
    if (this.hasLinkValidScript(code)) {
      this.findFn(this.getLinkValue(code))();
    } else if (this.hasLinkValidUrl(code)) {
      this.openUrlBlank(this.getLinkValue(code));
    } else {
      this.uiService.showWarningToast(`wrn.no_${code}_available`);
    }
  }

  isLinkActive(code: HelpLinks): boolean {
    return this.hasLinkValidUrl(code) || this.hasLinkValidScript(code);
  }

  private hasLinkValidUrl(code: HelpLinks): boolean {
    return isValidUrl(this.getLinkValue(code));
  }

  private hasLinkValidScript(code: HelpLinks): boolean {
    return typeof this.findFn(this.getLinkValue(code)) === 'function';
  }

  private getLinkValue(code: HelpLinks): string {
    const links = this.appService.getConfig().generic.helpLinks || [];
    const link = links.find(x => x[0] === code && !!x[1]);

    if (link) {
      return link[1];
    } else {
      return null;
    }
  }

  private openUrlBlank(url: string): void {
    window.open(url, '_blank');
  }

  private findFn(fnName: string): () => void {
    return (window as any)[fnName];
  }
}
